import { createConfig, http } from 'wagmi';
import { sepolia, mainnet } from 'wagmi/chains';
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'

// import { wagmiProjectID } from './config/config';

const projectId = '549ef9806a7268b35975a1bbee557640';

export const config = createConfig({
  chains: [mainnet], // Supported chains
  connectors: [
    // injected(),
    walletConnect({ projectId }),
    metaMask(),
    // 
  ],

  transports: {
    [sepolia.id]: http(),
    [mainnet.id]: http(),
  },
  // Enable support for chains outside the predefined ones
  // publicClient: {
  //   batch: true, // Enable batching to handle unsupported chains efficiently
  // },
});
